import React from 'react';
import { Outlet } from 'react-router-dom';
import HelmetWrapper from 'components/HelmetWrapper';

const SellerRouter: React.FC = () => {
  return (
    <>
      <HelmetWrapper title="Selling portfolio" />
      <Outlet />
    </>
  );
};

export default SellerRouter;
